import { render, staticRenderFns } from "./LoginTeacher.vue?vue&type=template&id=56814702&scoped=true&"
import script from "./LoginTeacher.vue?vue&type=script&lang=js&"
export * from "./LoginTeacher.vue?vue&type=script&lang=js&"
import style0 from "./LoginTeacher.vue?vue&type=style&index=0&id=56814702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56814702",
  null
  
)

export default component.exports